import sliceCreator from '../../index.jsx';
import { UPDATE_MANDAL} from '../../../constants/index.jsx';
const _updateMandalAction = sliceCreator('UPDATE_MANDAL', UPDATE_MANDAL, 'put');

const { asyncAction: updateMandalAction, reducer, clearData: clearUpdateMandalAction } = _updateMandalAction;

export default reducer;

export {
    updateMandalAction,
    clearUpdateMandalAction
}